interface CheckoutThemeProps {
    theme?: 'light' | 'dark';
}

interface GetCheckoutLinkProps extends CheckoutThemeProps {
    origin: string;
    id: string;
    storeSlug?: string;
    type?: 'regular' | 'digital';
    metricClientId?: string | number;
    expId?: string;
    isRootOrderStore?: boolean;
    bindingToken?: string;
    signature?: string;
    withOrderId?: boolean;
    isEdit?: boolean;
}

const getOrderTypePath = ({ type, isRootOrderStore }: Pick<GetCheckoutLinkProps, 'isRootOrderStore' | 'type'>) => {
    if (isRootOrderStore) {
        return '';
    }

    if (type === 'digital') {
        return '/digital-orders';
    }

    return '/orders';
};

const getStoreSlugPath = ({
    storeSlug,
    isRootOrderStore,
}: Pick<GetCheckoutLinkProps, 'isRootOrderStore' | 'storeSlug'>) => {
    if (isRootOrderStore) {
        return '';
    }

    if (storeSlug) {
        return `/${storeSlug}`;
    }

    return '';
};

/** Дополняет готовую ссылку из API или собирает адрес checkout из параметров заказа. */
export function getCheckoutLink(props: GetCheckoutLinkProps | (CheckoutThemeProps & { url: string })) {
    if ('url' in props) {
        if (!props.theme) {
            return props.url;
        }

        const url = new URL(props.url);

        url.searchParams.set('theme', props.theme);

        return url.toString();
    }

    const {
        origin,
        id,
        storeSlug,
        type = 'regular',
        metricClientId,
        expId,
        isRootOrderStore,
        bindingToken,
        signature,
        withOrderId = true,
        isEdit = false,
        theme,
    } = props;
    const orderTypePath = getOrderTypePath({ type, isRootOrderStore });
    const storeSlugPath = getStoreSlugPath({ storeSlug, isRootOrderStore });
    const orderIdPath = withOrderId ? `/${id}` : '';
    const editPath = isEdit ? '/edit' : '';

    const query = new URLSearchParams();

    if (signature) {
        query.set('signature', signature);
    } else if (bindingToken) {
        query.set('binding_token', decodeURIComponent(bindingToken));
    }

    if (metricClientId) {
        query.set('metricClientId', String(metricClientId));
    }

    if (expId) {
        query.set('expId', expId);
    }

    if (theme) {
        query.set('theme', theme);
    }

    const queryString = query.toString() ? `?${query.toString()}` : '';

    return `${origin}${orderTypePath}${storeSlugPath}${orderIdPath}${editPath}${queryString}`;
}
